import React, { useState } from "react";
import {
  Box, Button, Input, VStack, Heading, FormControl, FormLabel, Text, useToast
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const toast = useToast();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${window.location.origin}/api/login.php`,
        { username, password },
        { withCredentials: true }
      );
      toast({ title: "Erfolgreich eingeloggt", status: "success" });
      navigate("/ideen");
    } catch (err) {
      toast({
        title: "Login fehlgeschlagen",
        description: err.response?.data?.message || "Bitte prüfen Sie Ihre Eingabe",
        status: "error",
      });
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="gray.50">
      <Box bg="white" p={8} rounded="xl" shadow="lg" w="sm">
        <Heading mb={6} textAlign="center">Login</Heading>
        <form onSubmit={handleLogin}>
          <VStack spacing={4}>
            <FormControl>
              <FormLabel>Benutzername</FormLabel>
              <Input value={username} onChange={(e) => setUsername(e.target.value)} required />
            </FormControl>
            <FormControl>
              <FormLabel>Passwort</FormLabel>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </FormControl>
            <Button type="submit" colorScheme="teal" w="full">Einloggen</Button>
          </VStack>
        </form>
      </Box>
    </Box>
  );
};

export default LoginPage;

